import { NgModule, ModuleWithProviders} from '@angular/core';
import { RoutingHistoryService } from './services/routing-history.service';


@NgModule({
  imports: [],
  declarations: [],
  providers: [],
  exports:[]
})
export class RoutingModule {
  static forRoot(): ModuleWithProviders<RoutingModule> {
    return {
      ngModule: RoutingModule,
      providers: [
        RoutingHistoryService
      ]
    }
  }
}
